import instagramIcon from '../assets/Instagram_icon.png';
import tiktokIcon from '../assets/tiktok-app-icon-seeklogo.png';
import { MdMosque } from "react-icons/md";

const AboutProject = () => {
    return (
        <section id="about" className="py-24 px-6 md:px-12 bg-white">
            <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-16 md:gap-24 items-center">
                {/* Left Side: Clean minimal typography */}
                <div className="flex-1 space-y-8">
                    <h2 className="text-4xl md:text-5xl font-serif text-brand-green leading-tight">
                        About <br/><span className="italic text-gray-500">This Project</span>
                    </h2>
                    
                    <div className="w-12 h-0.5 bg-brand-green"></div>

                    <p className="text-lg text-gray-600 font-sans leading-relaxed">
                        Our growing Muslim community is in need of a dedicated space for worship and gathering. This mosque will
                        serve as a spiritual home for hundreds of families, providing a place for daily prayers, Islamic education, and
                        community support.
                    </p>

                    <p className="text-lg text-gray-600 font-sans leading-relaxed">
                        Every donation, no matter the size, brings us closer to our goal. May Allah reward your generosity and accept this
                        as <span className="italic">sadaqah jariyah</span> (ongoing charity).
                    </p>
                </div>
                
                {/* Right Side: Quote & Contact Info */}
                <div className="flex-1 bg-brand-cream p-10 md:p-14 border border-gray-200">
                    <div className="text-center space-y-8">
                        <MdMosque className="text-4xl text-brand-green mx-auto opacity-50" />
                        
                        <p className="text-xl md:text-2xl font-serif italic text-gray-800 leading-relaxed relative">
                            "The example of those who spend their wealth in the way of Allah is like a seed [of grain]
                            which grows seven spikes; in each spike is a hundred grains."
                        </p>
                        <p className="text-sm font-sans tracking-widest uppercase text-gray-500">- Quran 2:261</p>

                        <div className="pt-8 border-t border-gray-200 mt-8">
                            <p className="text-xs font-sans tracking-wider uppercase text-gray-400 mb-6">
                                For questions or more information
                            </p>
                            <div className="flex flex-col gap-4 text-left px-4">
                                <a href="https://instagram.com/husamjad01" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 hover:opacity-75 transition-opacity">
                                    <img src={instagramIcon} alt="Instagram" className="w-5 h-5 object-contain" />
                                    <span className="font-sans text-sm tracking-wide text-gray-700">@husamjad01</span>
                                </a>
                                <a href="https://tiktok.com/@husamjad01" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 hover:opacity-75 transition-opacity">
                                    <img src={tiktokIcon} alt="TikTok" className="w-5 h-5 object-contain" />
                                    <span className="font-sans text-sm tracking-wide text-gray-700">@husamjad01</span>
                                </a>
                                <a href="mailto:husam.m.jad@gmail.com" className="flex items-center gap-4 hover:opacity-75 transition-opacity">
                                    <svg className="w-5 h-5 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    <span className="font-sans text-sm tracking-wide text-gray-700">husam.m.jad@gmail.com</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutProject;